import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'small' | 'medium' | 'large';
  icon?: React.ReactNode;
  children: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({ 
  variant = 'primary', 
  size = 'medium',
  icon,
  children,
  className = '',
  ...props 
}) => {
  const baseStyles = "font-primary font-semibold rounded-lg flex items-center justify-center transition-all duration-200 cursor-pointer";
  
  const variantStyles = {
    primary: 'bg-accent-primary hover:bg-blue-600 text-white',
    secondary: 'bg-bg-secondary hover:bg-bg-primary text-white',
    ghost: 'text-text-secondary hover:text-text-primary'
  };
  
  const sizeStyles = {
    small: 'py-2 px-4 text-sm',
    medium: 'py-3 px-6 text-base',
    large: 'py-4 px-8 text-lg'
  };
  
  return (
    <button
      className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`}
      {...props}
    >
      {icon && <span className="mr-2">{icon}</span>}
      {children}
    </button>
  );
};

export default Button;